"use client";

import React from "react";
import {
  PriceConverterFormContainer,
  PriceConverterFormConversionDateContainer
} from "./styles";
import {
  Button,
  Card,
  Flex,
  SkeletonLoader,
  Text,
  mediaQuery
} from "@hubble/web";
import { useConverterPageContext } from "utils/converter-provider";
import { useTranslations } from "i18n";
import { FILES } from "i18n/constants";
import { format } from "date-fns";
import { web } from "@hubble/tokens";
import ConverterForm from "./ConverterForm/index";
import { useExchangeRateFetcher } from "./hooks/useExchangeRateFetcher";
import { useMedia } from "react-use";
import { formatCurrency } from "utils/currencies/formatters";
import { MAX_CRYPTO_PRECISION } from "constants/converter";

const PriceConverterForm: React.FC = () => {
  const t = useTranslations(FILES.CONVERTER);

  const isMobileXsDown = useMedia(mediaQuery.mobileXsDown, false);
  const { assetPrice, baseSlug, quoteSlug, isRouting } =
    useConverterPageContext();
  const { exchangeRate: exchangeRateUpdated } = useExchangeRateFetcher({
    baseSymbol: baseSlug,
    quoteSymbol: quoteSlug
  });

  const exchangeRate = parseFloat(
    parseFloat(
      String(exchangeRateUpdated) || assetPrice?.lastTradePrice || "0"
    ).toFixed(assetPrice?.priceInputDecimals ?? MAX_CRYPTO_PRECISION)
  );

  return (
    <PriceConverterFormContainer>
      <Card>
        <Flex alignItems="center" justifyContent="space-between">
          <Text.Heading size="md" marketing as="h1">
            {t("priceConverterFormTitle", {
              fromDisplayName: assetPrice?.toDisplayName,
              from:
                assetPrice?.toDisplayName !== assetPrice?.to
                  ? ` (${assetPrice?.to}) `
                  : "",
              toDisplayName: assetPrice?.fromDisplayName,
              to:
                assetPrice?.fromDisplayName !== assetPrice?.from
                  ? ` (${assetPrice?.from})`
                  : ""
            })}
          </Text.Heading>
          {!isMobileXsDown && (
            <Button.Brand
              style={{
                width: 200
              }}
              size="lg"
              href="https://exchange.gemini.com"
              target="_blank"
            >
              {t("buyCrypto")}
            </Button.Brand>
          )}
        </Flex>

        <ConverterForm exchangeRate={exchangeRate} />

        {/* conversion rate  */}
        <PriceConverterFormConversionDateContainer flexDirection="column">
          {isRouting ? (
            <SkeletonLoader height="28px" width="128px" />
          ) : (
            <Text.Body size="lg" marketing>
              1 {assetPrice?.to} = {formatCurrency(exchangeRate)}{" "}
              {assetPrice?.from}
            </Text.Body>
          )}
          <Text.Body color={web.color.base.gray[500]} size="sm" marketing>
            Last update: {format(new Date(), "h:mm aa, MMMM d, yyyy")}
          </Text.Body>
        </PriceConverterFormConversionDateContainer>
        {isMobileXsDown && (
          <Button.Brand
            style={{
              width: 200
            }}
            size="lg"
            href="https://exchange.gemini.com"
            target="_blank"
          >
            {t("buyCrypto")}
          </Button.Brand>
        )}
      </Card>
    </PriceConverterFormContainer>
  );
};

export default PriceConverterForm;
